// AllOptions.styles.ts
import styled from "styled-components";

interface ModalProps {
  cursorTop: number;
  cursorLeft: number;
  background: string;
}

export const Modal = styled.div<ModalProps>`
  position: absolute;
  top: ${(props) => props.cursorTop}px;
  left: ${(props) => props.cursorLeft}px;
  transform: translate(-50%, -50%);
  background: ${(props) => props.background};
  border-radius: 4px;
  z-index: 90;
  width: 30%;
`;

export const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #090a12;
  border-radius: 4px;
`;

export const DropdownItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: var(--sp-6);
  color: #090a12;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid #090a12;
  }
`;

export const DropdownItemTitle = styled.span`
  position: relative;
`;

export const Shortcut = styled.span`
  float: right;
`;
